<template>
  <FilterBoard
    class="tender-filter-row oms-list-filter"
    :show-heading="false"
    eyebrow=""
    title=""
  >
    <v-flex
      xs12
      sm6
      md2
      class="oms-filter-board__field tender-filter-field--type"
    >
      <v-select
        v-model="searchTypes"
        :items="Search"
        item-text="status"
        single-line
        item-value="abbr"
        disabled
        return-object
        hide-details
        outline
      ></v-select>
    </v-flex>
    <v-flex
      xs12
      sm6
      md3
      class="oms-filter-board__field oms-filter-board__field--search tender-filter-field--search"
    >
      <v-text-field
        class="gap"
        label="Search here.."
        outline
        single-line
        v-model="search"
        type="number"
        @keyup.enter="searchAnything"
        @click:append="searchAnything"
        append-icon="search"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex
      xs12
      sm6
      md2
      class="oms-filter-board__field tender-filter-field--status"
    >
      <v-select
        v-model="select"
        :items="jobStatus"
        item-text="status"
        single-line
        item-value="abbr"
        label="Status Filter"
        return-object
        outline
        hide-details
        @change="filterByJob"
      ></v-select>
    </v-flex>
    <v-flex
      xs12
      sm6
      md1
      class="reset oms-filter-board__actions tender-filter-field--reset"
    >
      <v-btn
        class="reset-btn-color oms-filter-board__reset"
        flat
        prepend-icon
        color="orange darken-1"
        @click.native="reset()"
      >
        Reset
        <v-icon color="orange">donut_large</v-icon>
      </v-btn>
    </v-flex>
  </FilterBoard>
</template>
<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import { StorageKeys } from "../../constants/constants";
import { EventBus } from "../../event-bus.js";
import FilterBoard from "@/components/Common/FilterBoard";
export default {
  components: {
    FilterBoard,
  },
  data() {
    return {
      select: { status: "All", abbr: "All" },
      searchTypes: { status: "Job Id", abbr: "jobId" },

      jobStatus: [
        { status: "All", abbr: "All" },
        { status: "Open", abbr: "Open" },
        { status: "Closed", abbr: "Closed" },
      ],
      Search: [{ status: "Job Id", abbr: "jobId" }],
      job: "",
      search: "",
    };
  },
  created() {
    this.$emit("job-Filter", this.select.abbr);
    EventBus.$on("countryChanged", (val) => {
      //this.reset();
    });
  },
  methods: {
    reset() {
      localStorage.removeItem("tenderJobFilter");
      localStorage.removeItem("tenderSearch");
      this.$emit("customer-reset", this.search);
      this.select = { status: "All", abbr: "All" };
      this.search = "";
    },

    filterByJob() {
      localStorage.setItem("tenderJobFilter", this.select.abbr);
      this.$emit("job-Filter", this.select.abbr);
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    searchAnything() {
      this.$emit("customer-search", this.search);
      this.$emit("filter-type", this.select.abbr);
    },
  },
};
</script>
